import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

export function useContactIconStyles() {
  const { semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      stack: {
        boxSizing: `border-box`,
        display: `inline-block`,
        lineHeight: `1em`,
        position: `relative`,
        verticalAlign: `middle`,
        width: `17px`,
        height: `16px`,
        cursor: `pointer`
      },
      userIcon: {
        left: 0,
        position: `absolute`,
        textAlign: `center`,
        width: `100%`
      },
      favoriteIcon: {
        color: semanticColors.inputFocusBorderAlt,
        bottom: 0,
        right: 0,
        position: `absolute`,
        textAlign: `center`,
        width: `100%`,
        fontSize: `10px`
      }
    }),
    [semanticColors]
  );
}
